const relasiData = [
  { num: 20, text: 'Memiliki' },
  { num: 108, text: 'Menggunakan' },
  { num: 67, text: 'Meminjam' },
];

export default relasiData;
